module.exports = __webpack_public_path__ + "img/blue-circular-cross-icon.aeedc55e.svg";